module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/87.472ae2e5.png";